import { aryaNotifyV1Client } from './BaseRepository';

export const getAnnouncements = paylaod => {
  return aryaNotifyV1Client.post(`announcements/_search`, paylaod);
};

export const updateAnnouncementView = id => {
  return aryaNotifyV1Client.post(`announcements/${id}/_read`);
};
